module.exports = __webpack_public_path__ + "media/images/logo-ampersand-f36dfed4b49ad96a941ebe438e2542fa.png";